import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Esport from "./pages/Esport";
import Salut from "./pages/Salut";
import Contacto from "./pages/Contacto";
import AvisoLegal from "./components/AvisoLegal";
import Privacidad from "./components/Privacidad";
import Cookies from "./components/Cookies";
import Precios from "./components/Precios";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
      {/*    <Header /> */}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/esport" element={<Esport />} />
        <Route path="/salut" element={<Salut />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/precios" element={<Precios />} />
        <Route path="/aviso-legal" element={<AvisoLegal />} />
        <Route path="/privacidad" element={<Privacidad />} />
        <Route path="/cookies" element={<Cookies />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
